import { VIcon, VSystemBar } from "vuetify/lib";
import { VueOfflineMixin } from "vue-offline";

export default {
	name: "KNetworkDownToolbar",

	mixins: [ VueOfflineMixin ],

	render() {
		return this.isOffline && <VSystemBar
			app
			class="d-print-none justify-center"
			color="error"
			dark
			slot="offline"
			window
		>
			<VIcon class="mr-2">signal_wifi_off</VIcon>
			Your device lost internet connection
		</VSystemBar>;
	}
};
